export const uk = {
    error: 'Что-то пошло не так, попробуйте повторить позже'
};
